<template>
  <div class="loader">
    <div class="loader__inner">
      <div class="dots"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TheLoader'
}
</script>

<style lang="scss">
.loader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  background-color: rgba(white, 0.9);

  &__inner {
    @include absolute-center;
  }

  .dots {
    overflow: hidden;
    display: inline-block;
    width: 7px;
    height: 7px;
    background: transparent;
    border-radius: 100%;
    box-shadow: #f86 -14px -14px 0 7px, #fc6 14px -14px 0 7px,
      #6d7 14px 14px 0 7px, #4ae -14px 14px 0 7px;
    animation: dots-loader 5s infinite ease-in-out;
    transform-origin: 50% 50%;
  }

  @keyframes dots-loader {
    0% {
      box-shadow: #f86 -14px -14px 0 7px, #fc6 14px -14px 0 7px,
        #6d7 14px 14px 0 7px, #4ae -14px 14px 0 7px;
    }
    8.33% {
      box-shadow: #f86 14px -14px 0 7px, #fc6 14px -14px 0 7px,
        #6d7 14px 14px 0 7px, #4ae -14px 14px 0 7px;
    }
    16.67% {
      box-shadow: #f86 14px 14px 0 7px, #fc6 14px 14px 0 7px,
        #6d7 14px 14px 0 7px, #4ae -14px 14px 0 7px;
    }
    25% {
      box-shadow: #f86 -14px 14px 0 7px, #fc6 -14px 14px 0 7px,
        #6d7 -14px 14px 0 7px, #4ae -14px 14px 0 7px;
    }
    33.33% {
      box-shadow: #f86 -14px -14px 0 7px, #fc6 -14px 14px 0 7px,
        #6d7 -14px -14px 0 7px, #4ae -14px -14px 0 7px;
    }
    41.67% {
      box-shadow: #f86 14px -14px 0 7px, #fc6 -14px 14px 0 7px,
        #6d7 -14px -14px 0 7px, #4ae 14px -14px 0 7px;
    }
    50% {
      box-shadow: #f86 14px 14px 0 7px, #fc6 -14px 14px 0 7px,
        #6d7 -14px -14px 0 7px, #4ae 14px -14px 0 7px;
    }
    58.33% {
      box-shadow: #f86 -14px 14px 0 7px, #fc6 -14px 14px 0 7px,
        #6d7 -14px -14px 0 7px, #4ae 14px -14px 0 7px;
    }
    66.67% {
      box-shadow: #f86 -14px -14px 0 7px, #fc6 -14px -14px 0 7px,
        #6d7 -14px -14px 0 7px, #4ae 14px -14px 0 7px;
    }
    75% {
      box-shadow: #f86 14px -14px 0 7px, #fc6 14px -14px 0 7px,
        #6d7 14px -14px 0 7px, #4ae 14px -14px 0 7px;
    }
    83.33% {
      box-shadow: #f86 14px 14px 0 7px, #fc6 14px -14px 0 7px,
        #6d7 14px 14px 0 7px, #4ae 14px 14px 0 7px;
    }
    91.67% {
      box-shadow: #f86 -14px 14px 0 7px, #fc6 14px -14px 0 7px,
        #6d7 14px 14px 0 7px, #4ae -14px 14px 0 7px;
    }
    100% {
      box-shadow: #f86 -14px -14px 0 7px, #fc6 14px -14px 0 7px,
        #6d7 14px 14px 0 7px, #4ae -14px 14px 0 7px;
    }
  }
}
</style>
